import React from 'react';
import { Switch, Route } from 'react-router-dom';
import About from './about.js';
import Downloads from './downloads/downloads.js';
import Docs from './docs/docs.js';
import Releases from './releases/releases.js';
import Contacts from './contacts.js';
import Poll from './poll.js';
import VdeDatasetViewer from './vde-dataset-viewer/vdeDatasetViewer.js';
import VdeDatasetViewerDownloads from './vde-dataset-viewer/downloads/vdeDatasetViewerDownloads.js';

function Main(props) {
    return (
        <main>
            <Switch>
                <Route exact path='/' component={About}/>
                <Route path='/downloads' render={() =>
                    <Downloads
                        currentVersion={props.currentVersion}
                        currentStableVersion={props.currentStableVersion}
                        currentViewerVersion={props.currentViewerVersion}
                    />
                }
                />
                <Route path='/docs' component={Docs}/>
                <Route path='/releases' component={Releases}/>
                <Route path='/contacts' component={Contacts}/>
                <Route path='/poll' component={Poll}/>
                <Route exact path='/vde-dataset-viewer' component={VdeDatasetViewer}/>
                <Route path='/vde-dataset-viewer/downloads' render={() =>
                    <VdeDatasetViewerDownloads
                        currentVersion={props.currentViewerVersion}
                    />
                }
                />
            </Switch>
        </main>
    );
}

export default Main;
